// extracted by mini-css-extract-plugin
export default {"btn":"LinkButton_btn__Xm80u","txt":"LinkButton_txt__VbIxo"};